<template>
    <div class="con-info">
        <div class="h-100 ns-info" style="min-height:100vh;">
        <SyaratAda/>
        </div>
    </div>
  </template>
  <script>
  import SyaratAda from '@/components/Syarat.vue'
  export default {
    components: {
      // Popup,
      SyaratAda,
    },
    data() {
      return {
        
      };
    },
    computed: {
      
    },
    mounted() {
      
    },
  };
  </script>
  <style>
  </style>
  <style scoped>
  .con-info{
    background: #114a8f;
    padding: 40px;
    margin: 0px;
  }
  .ns-info{
    min-height: 100vh;
    padding: 20px;
    background: #00000040;
    border-radius: 19px;
  }
  </style>
  